import utils from '@/utils'

/**
 * 時刻フィルター
 */
export default (value) => {
  return utils.cast.timeDisplay(value)
}
